import * as React from "react";
import HomeView from "../presentation/home";
import axios from 'axios';
import CONSTS from "../consts";
export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.getProducts = () => {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Products/ConnectMobile.Web.RandomSponsored(count=18)`;
            axios.get(query)
                .then((response) => {
                let products = response.data.value;
                this.setState({
                    products
                });
            });
        };
        this.state = {
            products: []
        };
    }
    componentDidMount() {
        this.getProducts();
    }
    render() {
        return (React.createElement(HomeView, { route: this.props.route, products: this.state.products }));
    }
}
;
//# sourceMappingURL=home.js.map